import { faChevronDown, faChevronUp, faQuestion } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useRef, useState } from 'react';
import { Collapse, Container } from 'react-bootstrap';
import './CollapsibleList.scss';

export function ComponenteHTML({ htmlString }) {
  const createMarkup = () => {
    return { __html: htmlString };
  };
  return <div className='resposta' dangerouslySetInnerHTML={createMarkup()} />;
}

export default function CollapsibleList({
  items,
  titleField = 'nome',
  contentField = 'texto',
  showQuestionIcon = false,
  sortByField = 'ordemExibicao'
}) {
  const buttonRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(null);

  const handleToggle = (index) => {
    if (currentIndex === index) {
      setCurrentIndex(null);
      buttonRef.current.blur();
    } else {
      setCurrentIndex(index);
    }
  };

  return (
    <Container fluid className='p-0'>
      {items &&
        items
          .sort((a, b) => a[sortByField] - b[sortByField])
          .map((item, index) => (
            <div className='box-pergunta' key={index}>
              <button
                ref={buttonRef}
                className='pergunta'
                onClick={() => handleToggle(index)}
                aria-controls={`collapse-text-${index}`}
                aria-expanded={currentIndex === index}
              >
                <div className='question-icon'>
                  {showQuestionIcon && <FontAwesomeIcon icon={faQuestion} />}
                  {item[titleField]}
                </div>
                <FontAwesomeIcon hidden={currentIndex === index} icon={faChevronDown} />
                <FontAwesomeIcon hidden={currentIndex !== index} icon={faChevronUp} />
              </button>
              <Collapse in={currentIndex === index}>
                <div id={`collapse-text-${index}`}>
                  <ComponenteHTML key={index} htmlString={item[contentField]} />
                </div>
              </Collapse>
            </div>
          ))}
    </Container>
  );
}